import { NonEmptyArray } from "ts-essentials"
import { map } from "lodash"
import { descriptorValidator } from "./helpers"
import { MultiStringOperatorType, SingleStringOperatorType } from "./strings"

/* Formatters */
function singleClassificationFormatter(id: string, operator: SingleStringOperatorType, dataType: "singleSelect", ...values: [{ tierId: string, value: string }]) {
  return {
    [operator]: { tier: values[0].tierId, value: values[0].value },
  }
}

function multiClassificationFormatter(id: string, operator: MultiStringOperatorType, dataType: "multiSelect", ...values: [{ tierId: string, value: string }, { tierId: string, value: string }]) {
  return {
    [operator]: map(values, ({ tierId, value }) => ({ tier: tierId, value })),
  }
}

/* Operators */
interface SingleClassificationOperator {
  label: string
  value: SingleStringOperatorType
  queryFormatter: typeof singleClassificationFormatter
  validator: typeof descriptorValidator
  selectorType: "singleSelect"
}

interface MultiClassificationOperator {
  label: string
  value: MultiStringOperatorType
  queryFormatter: typeof multiClassificationFormatter
  validator: typeof descriptorValidator
  selectorType: "multiSelect"
}

export const CLASSIFICATION_OPERATORS: NonEmptyArray<SingleClassificationOperator | MultiClassificationOperator> = [{
  label: "is",
  value: "eq",
  queryFormatter: singleClassificationFormatter,
  selectorType: "singleSelect",
  validator: descriptorValidator,
}, {
  label: "is not",
  value: "neq",
  queryFormatter: singleClassificationFormatter,
  selectorType: "singleSelect",
  validator: descriptorValidator,
}, {
  label: "is in",
  value: "in",
  queryFormatter: multiClassificationFormatter,
  selectorType: "multiSelect",
  validator: descriptorValidator,
}, {
  label: "is not in",
  value: "notIn",
  queryFormatter: multiClassificationFormatter,
  selectorType: "multiSelect",
  validator: descriptorValidator,
}] as const
